export default __webpack_public_path__ + "static/media/toggler-plus.4a9bb415.svg";